import ReviewSection from './ReviewSection'

export default ReviewSection
